import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { ugcSimilarTitlesShape, bibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import BibBrief from 'app/components/shared/BibBrief';
import ItemFormat from 'app/components/shared/ItemFormat';
import JacketCoverContainer from 'app/components/shared/JacketCover/JacketCoverContainer';

import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';

import './SimilarTitleDisplay.scss';

export default class SimilarTitleDisplay extends React.PureComponent {
  constructor(props) {
    super(props);

    bindAll(this);
  }

  renderActions(briefInfo) {
    const { similarTitlesActions, similarTitlesTransactions, similarTitle, owner } = this.props;

    if (owner.get('loggedIn')) {
      const similarTitleId = similarTitle.get('id');
      const metadataId = similarTitle.get('metadataId');
      const title = briefInfo.get('title');
      const handleRemove = () => similarTitlesActions.removeSimilarTitle(metadataId, similarTitleId);
      const isRemoving = similarTitlesTransactions.getIn([metadataId, similarTitleId, 'isRemoving'], false);
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_similar_title" values={{ title }} />;

      return (
        <DisplayActions
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  renderBibBrief(similarTitleBib) {
    const briefInfo = similarTitleBib.get('briefInfo');

    return (
      <div className="similar-titles-bib-brief-info">
        <BibBrief
          bib={briefInfo}
          renderTitleAsLink={!!briefInfo.get('id')}
          titleTag="h5"
          truncateTitleOptions={{ desiredLength: 50 }}
        >
          <ItemFormat bib={similarTitleBib} />
        </BibBrief>
        {this.renderActions(briefInfo)}
      </div>
    );
  }

  render() {
    const briefInfo = this.props.similarTitleBib.get('briefInfo');

    return (
      <DisplayWrapper className="cp-ugc-similar-title-display">
        <div className="jacket-cover-container">
          <JacketCoverContainer src={briefInfo.get('jacket')} format={briefInfo.get('format')} alt="" />
        </div>
        {this.renderBibBrief(this.props.similarTitleBib)}
      </DisplayWrapper>
    );
  }
}

SimilarTitleDisplay.propTypes = {
  similarTitleBib: bibShape.isRequired,
  similarTitle: ugcSimilarTitlesShape.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  owner: userIdentityShape.isRequired
};
